export default __webpack_public_path__ + "static/media/FifthImage.72efd32a.png";